import { render } from "./PeopleContactsCard.vue?vue&type=template&id=6555fe2a&scoped=true"
import script from "./PeopleContactsCard.vue?vue&type=script&lang=js"
export * from "./PeopleContactsCard.vue?vue&type=script&lang=js"

import "@/assets/scss/domains/app/components/people/detail/_people-contacts-card.scss?vue&type=style&index=0&id=6555fe2a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6555fe2a"]])

export default __exports__